import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Separator from './Separator';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const FareItemRoute = (props) => {
  const {
    showOrigin,
    origin,
    originStyles,
    separatorLabel,
    showDestination,
    destination,
    destinationStyles,
  } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fare-item-route ${className}`} style={style}>
      {showOrigin && (
        <Text {...originStyles} floatLeft>
          {origin}
        </Text>
      )}
      {showDestination && showOrigin && origin && destination && (
        <Separator {...separatorLabel} floatLeft />
      )}
      {showDestination && (
        <Text {...destinationStyles} floatLeft>
          {destination}
        </Text>
      )}
    </Box>
  );
};

FareItemRoute.propTypes = {
  /**
   * Show Origin.
   */
  showOrigin: PropTypes.bool,
  /**
   * Origin.
   */
  origin: PropTypes.string,
  /**
   * originStyles props for using into withStyle.
   */
  originStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * separatorLabel props for using into withStyle.
   */
  separatorLabel: PropTypes.objectOf(PropTypes.any),
  /**
   * Show Destination.
   */
  showDestination: PropTypes.bool,
  /**
   * Destination.
   */
  destination: PropTypes.string,
  /**
   * destinationStyles props for using into withStyle.
   */
  destinationStyles: PropTypes.objectOf(PropTypes.any),
};
FareItemRoute.defaultProps = {
  showOrigin: true,
  origin: '',
  originStyles: {},
  separatorLabel: {},
  showDestination: true,
  destination: '',
  destinationStyles: {},
};

FareItemRoute.componentName = 'FareItemRoute';

export default FareItemRoute;
